<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication"><a id="page_ix"></a>For Jeanine, who deserves more than I can ever give.<br/>And for my mother, Chris McGinniss, who raised me.<br/>And for my son, Julien, I had no idea.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?9d468c46